import { MonthlyReport } from './models/monthly-report.model';
import { Routes } from '@angular/router';
import { InquiryListComponent } from './components/inquiry/inquiry-list/inquiry-list.component';
import { InquiryCreateComponent } from './components/inquiry/inquiry-create/inquiry-create.component';
import { InquiryDetailComponent } from './components/inquiry/inquiry-detail/inquiry-detail.component';
import { AdminDashboardComponent } from './components/admin/dashboard/admin-dashboard.component';
import { AdminInquiryListComponent } from './components/admin/inquiry-list/admin-inquiry-list.component';
import { AdminInquiryDetailComponent } from './components/admin/inquiry-detail/admin-inquiry-detail.component';
import { ContactComponent } from './components/contact/contact.component';
import { LoginComponent } from './components/login/login.component';
import { AdminWithdrawalListComponent } from './components/admin/withdrawal-list/admin-withdrawal-list.component';
import { AdminWithdrawalDetailComponent } from './components/admin/withdrawal-detail/admin-withdrawal-detail.component';
import { AdminSearchUserComponent } from './components/admin/search-user/admin-search-user.component';
import { CorrectionListComponent } from './components/correction/correction-list/correction-list.component';
import { CorrectionCreateComponent } from './components/correction/correction-create/correction-create.component';
import { CorrectionDetailComponent } from './components/correction/correction-detail/correction-detail.component';
import { AdminCorrectionListComponent } from './components/admin/correction-list/admin-correction-list.component';
import { AdminCorrectionDetailComponent } from './components/admin/correction-detail/admin-correction-detail.component';
import { AdminWeeklyReportComponent } from './components/admin/weekly-report/admin-weekly-report.component';
import { WeeklyReportComponent } from './components/weekly-report/weekly-report.component';
import { AdminMonthlyReportComponent } from './components/admin/monthly-report/admin-monthly-report.component';
import { MonthlyReportSimpleComponent } from './components/monthly-report-simple/monthly-report-simple.component';
import { MonthlyProfitSimpleComponent } from './components/monthly-profit-simple/monthly-profit-simple.component';
import { InvestCreateComponent } from './components/invest/invest-create/invest-create.component';
import { WithdrawalCreateComponent } from './components/withdrawal/withdrawal-create/withdrawal-create.component';
import { WithdrawalListComponent } from './components/withdrawal/withdrawal-list/withdrawal-list.component';
import { WithdrawalDetailComponent } from './components/withdrawal/withdrawal-detail/withdrawal-detail.component';
import { TransferCreateComponent } from './components/transfer/transfer-create/transfer-create.component';
import { TransferListComponent } from './components/transfer/transfer-list/transfer-list.component';
import { TransferDetailComponent } from './components/transfer/transfer-detail/transfer-detail.component';
import { InvestListComponent } from './components/invest/invest-list/invest-list.component';
import { AdminWithdrawalTransactionListComponent } from './components/admin/withdrawal-transaction/admin-withdrawal-transaction-list.component';
import { AdminWithdrawalTransactionDetailComponent } from './components/admin/withdrawal-transaction-detail/admin-withdrawal-transaction-detail.component';
import { MonthlyReportComponent } from './components/monthly-report/monthly-report.component';
import { InvestDetailComponent } from './components/invest/invest-detail/invest-detail.component';

export const routes: Routes = [
  { path: '', component: ContactComponent },
  { path: 'login', component: LoginComponent },

  // { path: 'weeklyReport', component: WeeklyReportComponent },
  { path: 'monthlyReport', component: MonthlyReportComponent },

  // { path: 'monthlyReportSimple', component: MonthlyReportSimpleComponent },
  { path: 'monthlyProfitSimple', component: MonthlyProfitSimpleComponent },

  { path: 'inquiry', component: InquiryListComponent },
  { path: 'inquiry/create', component: InquiryCreateComponent },
  { path: 'inquiry/:id', component: InquiryDetailComponent },

  { path: 'invest', component: InvestListComponent },
  { path: 'invest/create', component: InvestCreateComponent },
  { path: 'invest/:id', component: InvestDetailComponent },


  { path: 'transfer', component: TransferListComponent },
  { path: 'transfer/create', component: TransferCreateComponent },
  { path: 'transfer/:id', component: TransferDetailComponent },

//  { path: 'correction', component: CorrectionListComponent },
//  { path: 'correction/create', component: CorrectionCreateComponent },
//  { path: 'correction/:id', component: CorrectionDetailComponent },

  { path: 'withdrawal', component: WithdrawalListComponent },
  { path: 'withdrawal/create', component: WithdrawalCreateComponent },
  { path: 'withdrawal/:id', component: WithdrawalDetailComponent },

  { path: 'admin', component: AdminDashboardComponent },
  { path: 'admin/inquiry', component: AdminInquiryListComponent },
  { path: 'admin/inquiry/:id', component: AdminInquiryDetailComponent },

//  { path: 'admin/correction', component: AdminCorrectionListComponent },
//  { path: 'admin/correction/:id', component: AdminCorrectionDetailComponent },

//  { path: 'admin/withdrawal', component: AdminWithdrawalListComponent },
//  { path: 'admin/withdrawal/:id', component: AdminWithdrawalDetailComponent },

  { path: 'admin/search/user', component: AdminSearchUserComponent },
  { path: 'admin/weeklyReport', component: AdminWeeklyReportComponent },

  { path: 'admin/monthlyReport', component: AdminMonthlyReportComponent },

  { path: 'admin/withdrawalTransaction', component: AdminWithdrawalTransactionListComponent },
  { path: 'admin/withdrawalTransaction/:id', component: AdminWithdrawalTransactionDetailComponent }



];
